import styled from "styled-components";
import { styledByTheme } from "../../../../themes/architecture/styled-by-theme";
import { CssRule } from "../../../../themes/architecture/css-helpers/css-rule";

const LogOutLinkDefaultBox = styled.a`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 1.2rem 1rem 1.2rem 2.5rem;
    font-size: 1.2rem;
    line-height: 1;
    transition: color 0.2s ease;
    color: ${props => props.theme.colors.text};
    background-color: ${props => props.theme.colors.background};

    ${CssRule.For.RTL.build()} &{
        padding: 1.2rem 1.5rem;
    }

    ${CssRule.For.desktop.build()} &{
        font-weight: 500;
        font-size: 1.3rem;
        ${({theme}) => theme.font.presets.body};
        padding: 1.2rem 2rem 1.2rem 3.85rem;
    }

    ${CssRule.For.mobile.build()} &{
        padding: 1.7rem 1rem 1.7rem 2.5rem;
        font-size: 1.6rem;
        font-weight: 300;
        color: ${props => props.theme.colors.textLight};
    }

    &:hover {
        background-color: ${props => props.theme.colors.backgroundHover};
        color: ${props => props.theme.colors.textHover};
    }

    &:after {
        content: "";
        width: 17px;
        height: 14px;
        background-image: url("${({theme}) => theme.images.spriteSheet.toString()}");
        background-repeat: no-repeat;
        background-position: -820px -653px;

        ${CssRule.For.RTL.build()} &{
            transform: scaleX(-1);
        }
    }
`;

const LogOutLinkCasino777Box = styled(LogOutLinkDefaultBox)`
    padding: 1rem 1.5rem;
    ${({theme}) => theme.font.presets.body};
    font-size: 1.4rem;


    ${CssRule.For.mobile.build()} &{
        padding: 1.7rem 1rem 1.7rem 2rem;
        font-size: 1.8rem;
        font-weight: 700;
    }
    &:after {
        background-position: -641px -577px;
    }
`;

const LogOutLinkMrGreenBox = styled(LogOutLinkDefaultBox)`
    &:hover {
        background-color: ${props => props.theme.colors.background};
    }
`;

export const LogOutLinkBox = styledByTheme(LogOutLinkDefaultBox)
    .forCasino777(LogOutLinkCasino777Box)
    .forMrGreen(LogOutLinkMrGreenBox)
    .apply();
